import { render, staticRenderFns } from "./client-detail-endereco-cobranca.vue?vue&type=template&id=401bd2de&scoped=true"
import script from "./client-detail-endereco-cobranca.vue?vue&type=script&lang=js"
export * from "./client-detail-endereco-cobranca.vue?vue&type=script&lang=js"
import style0 from "./client-detail-endereco-cobranca.vue?vue&type=style&index=0&id=401bd2de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bd2de",
  null
  
)

export default component.exports